import Lottie from 'react-lottie-segments';
import animationData from '../../../../assets/lottie/file_upload_loader.json';

type LottieLoadingProps = {
  isStopped: boolean,
  loop: boolean,
  autoplay: boolean,
}

export const LottieLoading = ({
  isStopped,
  loop,
  autoplay,
}: LottieLoadingProps): JSX.Element => {
  const loaderOptions = {
    loop,
    autoplay,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div key={ `${isStopped}` }>
      <Lottie
        options={ loaderOptions }
        isStopped={ isStopped }
        playSegments={ isStopped ? undefined : {
          segments: [11, 176],
          forceFlag: true,
        } }
        height={ 64 }
        width={ 64 }
      />
    </div>
  );
};
